<template>
  <div class="app">
    <div class="d-flex h-100 justify-content-center align-items-center">
      <div class="mx-auto app-login-box col-md-8">
        <div class="mb-3 d-flex align-items-center justify-content-center">
          <img v-show="temLogoClienteNaSessao" :src="logoCliente" alt="" width="200" class="tenant-logo brand-image mt-1 ml-3 mr-3"/>
          <img alt="logo" :src="obterLogo" width="200" class="office-logo brand-image img-fluid">
        </div>

        <div class="modal-dialog w-100 mx-auto">
          <div class="modal-content">
            <div class="modal-body">
              <div class="modal-title">

                <div class="avisoDanger mensagemAlerta" v-show="retorno.mensagemErro">
                  {{ retorno.mensagemErro }}
                </div>

                <div class="textos text-center mb-3">
                  Informe o código enviado para seu e-mail.
                </div>

                <div v-if="flags.efetuandoRequisicao" class="divLoginSpinner mb-3">
                  <span class="avisoDanger">Por favor, aguarde...</span>
                  <b-spinner class="ml-2" variant="danger"></b-spinner>
                </div>
              </div>

              <form>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    @keyup="eventoLoginTeclaEnter"
                    autocomplete="off"
                    name="codigo2fa"
                    id="codigo2fa"
                    maxlength="6"
                    class="form-control campoSemBordaDireita corBordaCampo placeholder"
                    v-model="formulario.codigo"
                    placeholder="Código de verificação..."
                  >
                  <div class="input-group-append">
                    <div class="input-group-text fundoBotaoIcone corBordaCampo">
                      <i class="fa fa-key fa-cor"></i>
                    </div>
                  </div>
                </div>

                <div class="textos text-center mb-3" v-if="contador > 0">
                  Você poderá reenviar um novo código em {{ contador }}s.
                </div>

                <div class="textos text-center mb-3" v-if="retorno.mensagemSucesso">
                  {{ retorno.mensagemSucesso }}
                </div>

                <div id="acesso" class="mt-2">
                  <b-button
                    variant="btn btn-secondary btn-sm botaoLogin"
                    :disabled="flags.efetuandoRequisicao || formulario.codigo.length !== 6"
                    @click="validarCodigo">
                    Validar Código
                  </b-button>

                  <a
                    v-if="contador === 0"
                    href="#"
                    class="linkOutroEscritorio textos"
                    :class="{ disabled: flags.efetuandoRequisicao }"
                    @click.prevent="reenviarCodigo">
                    Reenviar código
                  </a>

                  <p class="textos text-center">
                    Não esqueça de verificar sua caixa de SPAM.
                  </p>
                  <router-link
                    :to="{name: 'login'}"
                    :disabled="flags.efetuandoRequisicao"
                    class="small mt-3">
                    <span>Voltar para o login</span>
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Validacao2faLogin from './js/validacao2faLogin'
export default Validacao2faLogin
</script>

<style scoped>
@import "./scss/login.scss";
</style>
